// extracted by mini-css-extract-plugin
export default {"notification":"notifications-configurator_notification__AdNoi"};